var app = globalThis;
globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ModalLibraryItemsSelection = (function(superClass) {
  utils.extend(ModalLibraryItemsSelection, superClass);

  function ModalLibraryItemsSelection($html) {
    this.$html      = $html;
    this.$from      = $html.find('.library-items-wrapper:first');
    this.$to        = $html.find('.library-items-wrapper:last');
    this.maxChoices = $html.data('max-choices');

    return ModalLibraryItemsSelection.__super__.constructor.apply(this, arguments);
  }

  ModalLibraryItemsSelection.prototype.init = function() {
    this.sendLibraryItem();
    this.setLibraryItemsWidth();
    this._manageMaxChoices(this.$from, this.$to);

    SearchFilter.initFilters(this.$html.find('input.filter'));

    return ModalLibraryItemsSelection.__super__.init.apply(this, arguments);
  };

  ModalLibraryItemsSelection.prototype.setLibraryItemsWidth = function() {
    return this.$html.find('.library-item:not(.label-content-image)').each(function() {
      var $this, width;
      $this = $(this);
      width = $this.width();
      return $this.find('span').css('max-width', (width - 50) + "px");
    });
  };

  ModalLibraryItemsSelection.prototype.sendLibraryItem = function() {
    var self = this;

    return this.$html.on('click', '.send-library-item', function(e) {
      var $libraryItem, $target, $this, data;
      $this = $(this);
      $('body').find('.sb-tu-tooltip-box').remove();
      if ($this.hasClass('select')) {
        data = $this.data('library-item');
        if ((data.id != null) && (data.label != null)) {
          self._toggleNoOptionsLabel(self.$to, true);
          $this.closest('.label-content-container').clone().hide().appendTo(self.$to)
                                                           .find('.select').hide()
                                                           .end()
                                                           .find('.deselect').show()
                                                           .end()
                                                           .find('input').prop('disabled', false)
                                                           .end()
                                                           .fadeIn();

          appCustomerSpace.LimitlessPlugins.initPlugins(self.$to);
          self._toggleLibraryItem($this.closest('.library-item'));
          self._manageMaxChoices(self.$from, self.$to);
          self._updateCounter(self.$to);
        }
      } else {
        $libraryItem = $this.closest('.label-content-container');
        $libraryItem.fadeOut(function() {
          var id;
          id = $libraryItem.data('id');
          self._toggleLibraryItem($("#modal-library-item-" + id), false);
          self._toggleNoOptionsLabel(self.$to);
          return $.when($libraryItem.remove()).done(function() {
            self._manageMaxChoices(self.$from, self.$to);
            return self._updateCounter(self.$to);
          });
        });
      }
      return false;
    });
  };

  ModalLibraryItemsSelection.prototype.callbackSuccess = function(data) {
    if (data.response && this.$html.data('target')) {
      $container = $(this.$html.data('target'));
      $container.html(data.html);

      appCustomerSpace.creationForm.currentStep.handleItemArrows($container);
      appCustomerSpace.LimitlessPlugins.initPlugins($container);

      $('body').trigger('job_form.change', [$container.parent()]);
    }
    return ModalLibraryItemsSelection.__super__.callbackSuccess.apply(this, arguments);
  };

  ModalLibraryItemsSelection.prototype._toggleLibraryItem = function($libraryItem, disable) {
    if (disable == null) {
      disable = true;
    }
    if (disable) {
      return $libraryItem.addClass('disabled').find('.send-library-item').attr('disabled', '');
    } else {
      return $libraryItem.removeClass('disabled').find('.send-library-item').removeAttr('disabled');
    }
  };

  ModalLibraryItemsSelection.prototype._toggleNoOptionsLabel = function($container, hide) {
    if (hide == null) {
      hide = false;
    }
    $label = $('.no-options');
    if (hide && $label.is(':visible')) {
      return $label.hide();
    } else if ($container.find('.library-item:visible').length == 0) {
      return $label.show();
    }
  };

  ModalLibraryItemsSelection.prototype._manageMaxChoices = function($from, $to) {
    var self = this;
    if (this.maxChoices) {
      if ($to.find('.library-item').length >= this.maxChoices) {
        return $from.find('.library-item:not(.disabled)').addClass('max-choices-reached').each(function() {
          return self._toggleLibraryItem($(this));
        });
      } else {
        return $from.find('.max-choices-reached').removeClass('max-choices-reached').each(function() {
          return self._toggleLibraryItem($(this), false);
        });
      }
    }
  };

  ModalLibraryItemsSelection.prototype._updateCounter = function($container) {
    var $el      = $container.siblings('.library-items-counter-container'),
        $counter = $el.find('.library-items-counter'),
        $label   = $el.find('.library-items-label'),
        counter  = $container.find('.library-item').length;

    $counter.text(counter);

    if (counter === 1) {
      return $label.text($el.data('library-items-singular'));
    } else {
      return $label.text($el.data('library-items-plural'));
    }
  };

  return ModalLibraryItemsSelection;

})(appCustomerSpace.ModalCreationFormSubmissionFunnel);
